<template>
  <!--遮罩层开始-->
  <div class="loading-mask-wrap" onselectstart="return false">
    <transition name="fade">
      <div class="loading-mask" v-show="show">
        <img class="icon-loading" src="/static/loading/loading-spin.svg" alt="loading"/>
      </div>
    </transition>
  </div>
  <!--遮罩层结束-->
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'loading',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "loading.styl";
</style>



// WEBPACK FOOTER //
// src/components/loading/loading.vue